module.exports = __webpack_public_path__ + "static/media/insufficientFailed.8b5e5734.png";